import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import configureFyhStore from '../redux/configureFyhStore';
import Fyh from '../components/fyh';

const store = configureFyhStore();
const composed = () => {
  return (
    <Provider store={store}>
      <Fyh />
    </Provider>
  );
};

const container = document.getElementById('fyh-container');
if (container) {
  ReactDOM.render(composed(), container);
}

if (module && module.hot) {
  module.hot.accept();
}
